
import { useEffect, useState } from 'react';
import MapView from './components/mapView.js'
import ListView from './components/listView.jsx'
import AppBar from './components/appbar'
import { useParams, useLocation, useNavigate, useSearchParams } from 'react-router-dom';



function MyMap(props) {
  const { poi, trip } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [markers, setMarkers] = useState([]);
  const [showInfo, setShowInfo] = useState(false)
  const [trips, setTrips] = useState([]);
  const [isDetailOpen, setIsDetailOpen] = useState(poi ? true : false);
  const [selectedLoc, setSelectedLoc] = useState(poi ? poi : undefined);
  const [selectedTrip, setSelectedTrip] = useState(undefined)
  const [lastSelectedLoc, setLastSelectedLoc] = useState(undefined)
  const [tripFilter, setTripFilter] = useState()
  const [view, setView] = useState("map")
  const viewValue = searchParams.get('view');
  

  useEffect(() => {

    const fetchMarkers = async () => {
      try {
        const _tripId = trip ? trip.split("_")[1] || trip : ""
        //const url = trip ? `/api/trips?tripId=${_tripId}` : '/api/trips'
        const response = await fetch('/api/trips')
        const allTrips = await response.json()
        if (trip) {
          const _tripId = trip ? trip.split("_")[1] || trip : ""
          if (_tripId) {
            setTripFilter(allTrips.find(trip => trip._id === _tripId))
          }
        }
        setTrips(allTrips)
      } catch (e) {
        console.log(e)
      }

    };
      if (!poi && markers.length < 1) {
        fetchMarkers();
    }
  }, [poi, trip]);
  
  useEffect(()=>{
    if (viewValue && (viewValue === "map" || viewValue === "list")) {
      setView(viewValue)
    }
  }, [viewValue])

  useEffect(()=> {

    if (poi) {
      setSelectedLoc(poi);
      setIsDetailOpen(true)
    } else {
      setSelectedLoc(undefined);
      setIsDetailOpen(false)

    }
}, [poi])

useEffect(()=>{
    if (tripFilter) {
        if (tripFilter !== "all-trips") {
            const urlPath = tripFilter.slug ? `${tripFilter.slug}_${tripFilter._id}` : tripFilter._id 
            navigate(`/trip/${urlPath}`)
        } else {
            navigate(`/`)
        }
    } 
    
}, [tripFilter])



useEffect(()=> {
  if (location.state) {
    setLastSelectedLoc({trip: location.state.trip, loc: location.state.loc})
  }
}, [location])

  const page = window.location.pathname.split("/")[1]
  

  return (
    <div>
      {page !== "poi" && (<AppBar
        setOpen={setShowInfo}
        trips={trips}
        tripFilter={tripFilter}
        setTripFilter={setTripFilter}
        view={view}
        setView={setView}
      />)}
      {view === "map" ? <MapView 
        trips={tripFilter && tripFilter!=="all-trips" ? trips.filter(trip => trip._id === tripFilter._id) : trips}
        selectedTrip={selectedTrip}
        selectedLoc={selectedLoc}
        setSelectedLoc={setSelectedLoc}
        setSelectedTrip={setSelectedTrip}
        isDetailOpen={isDetailOpen}
        lastSelectedLoc={lastSelectedLoc}
        setIsDetailOpen={setIsDetailOpen}
        tripFilter={tripFilter}
    /> :
    <ListView
        trips={tripFilter && tripFilter!=="all-trips" ? trips.filter(trip => trip._id === tripFilter._id) : trips}
        selectedTrip={selectedTrip}
        selectedLoc={selectedLoc}
        setSelectedLoc={setSelectedLoc}
        setSelectedTrip={setSelectedTrip}
        isDetailOpen={isDetailOpen}
        lastSelectedLoc={lastSelectedLoc}
        setIsDetailOpen={setIsDetailOpen}
        tripFilter={tripFilter}
    />}     
    </div>
  )
}
export default MyMap;
